// src/pages/beta-community/BetaCommunityPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './BetaCommunity.css';

// Import des composants enfants
import HeroSection from './components/HeroSection';
import VideoSection from './components/VideoSection';
import FeaturesSection from './components/FeaturesSection';
import OfferSection from './components/OfferSection';
import PlansSection from './components/PlansSection';
import TimelineSection from './components/TimelineSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const BetaCommunityPage = () => {
  const navigate = useNavigate();
  const [, setIsScrolled] = useState(false);

  // Gestion du scroll pour les animations
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll smooth vers une section
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="beta-community-page" style={{ fontFamily: "'Georgia', serif" }}>
      {/* Hero principal */}
      <HeroSection scrollToSection={scrollToSection} />

      {/* Vidéo démo */}
      <VideoSection />

      {/* Features principales */}
      <FeaturesSection />

      {/* Offre beta */}
      <OfferSection />

      {/* Plans disponibles */}
      <PlansSection scrollToSection={scrollToSection} />

      {/* Timeline - Comment ça marche */}
      <TimelineSection />

      {/* CTA final */}
      <CTASection navigate={navigate} />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default BetaCommunityPage;